<template>
  <div 
    class="dockmenu-content-elements"
  >
    <div 
      id="content-elements-scrollbar"
      class="content-elements-scrollbar"
    >
      <div class="content-elements-elements justify-content-center">
        <type
          :key="type.component"
          :icon="type.icon"
          :type="type.component"
          :title="type.name"
          v-for="type in types"
          :visible="type.visibility"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Type from './Type'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
var sequence_addon = window.xitFlowBuilderData.sequence_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon
var instagram_addon = window.xitFlowBuilderData.instagram_addon
var user_input_flow_addon = window.xitFlowBuilderData.user_input_flow_addon
var messenger_bot_condition = window.xitFlowBuilderData.messenger_bot_condition
var is_system_generated_action = !! window.xitFlowBuilderData.is_system_generated_action
var is_openai_addon_access = !!window.xitFlowBuilderData.is_openai_addon_access
var http_api_module = !! window.xitFlowBuilderData.http_api_module

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default {
  name: 'Elements',
  components: {
    Type,
  },
  data: () => ({
    elementContentHeight: null,
    types: [
      {
        icon: 'fas fa-paragraph text',
        name: lingualName.TEXT,
        component: CONST_COMPONENT.TEXT,
        visibility: 1,
      },

      {
        icon: 'fas fa-camera-retro image',
        name: lingualName.IMAGE,
        component: CONST_COMPONENT.IMAGE,
        visibility: 1,
      },

      {
        icon: 'fas fa-microphone-alt audio',
        name: lingualName.AUDIO,
        component: CONST_COMPONENT.AUDIO,
        visibility: 1,
      },

      {
        icon: 'fab fa-youtube video',
        name: lingualName.VIDEO,
        component: CONST_COMPONENT.VIDEO,
        visibility: 1,
      },

      {
        icon: 'fas fa-paperclip file',
        name: lingualName.FILE,
        component: CONST_COMPONENT.FILE,
        visibility: instagram_addon ? 0 : 1,
      },

      {
        icon: 'fab fa-facebook fb-media',
        name: lingualName.FACEBOOK_MEDIA,
        component: CONST_COMPONENT.FACEBOOK_MEDIA,
        visibility: instagram_addon ? 0 : 1,
      },

      {
        icon: 'fas fa-address-card generic',
        name: lingualName.GENERIC_TEMPLATE,
        component: CONST_COMPONENT.GENERIC_TEMPLATE,
        visibility: 1,
      },   

      {
        icon: 'fas fa-images carousel',
        name: lingualName.CAROUSEL,
        component: CONST_COMPONENT.CAROUSEL,
        visibility: 1,
      },    

      {
        icon: 'fas fa-comment-dots quick-reply',
        name: lingualName.QUICK_REPLY,
        component: CONST_COMPONENT.QUICK_REPLY,
        visibility: 0,
      },

      {
        icon: 'fas fa-shopping-cart ecommerce',
        name: lingualName.ECOMMERCE,
        component: CONST_COMPONENT.ECOMMERCE,
        visibility: 1,
      },

      {
        icon: 'fas fa-greater-than-equal conditional-reply',
        name: lingualName.CONDITION,
        component: CONST_COMPONENT.CONDITION,
        visibility: messenger_bot_condition ? 1 : 0,
      },

      {
        icon: 'fas fa-fill-drip drip',
        name: lingualName.SEQUENCE,
        component: CONST_COMPONENT.SEQUENCE,
        visibility: sequence_addon,
      },

      {
        icon: 'fab fa-stack-overflow input-flow',
        name: lingualName.USER_INPUT_FLOW,
        component: CONST_COMPONENT.USER_INPUT_FLOW,
        visibility: user_input_flow_addon,
      },

      // {
      //   icon: 'fas fa-bell otn',
      //   name: lingualName.OTN,
      //   component: CONST_COMPONENT.OTN,
      //   visibility: instagram_addon ? 0 : 1,
      // },    

      {
        icon: 'fas fa-mail-bulk rcn',
        name: lingualName.RCN,
        component: CONST_COMPONENT.RECURRING_NOTIFICATION,
        visibility: recurring_notification_display,
      }, 

      {
        icon: 'fas fa-robot trigger-keyword',
        name: lingualName.OPEN_AI,
        component: CONST_COMPONENT.OPEN_AI,
        visibility: is_openai_addon_access ? 1 : 0,
      },  

      {
        icon: 'fa-solid fa-plug file',
        name: lingualName.HTTP_API,
        component: CONST_COMPONENT.HTTP_API,
        visibility: http_api_module ? 1 : 0,
      }, 

      // {
      //   icon: 'fas fa-rocket trigger-keyword',
      //   name: lingualName.TRIGGER,
      //   component: CONST_COMPONENT.TRIGGER,
      //   visibility: 1,
      // },

      {
        icon: 'fas fa-hand-pointer click-action-button',
        name: lingualName.ACTION_BUTTON,
        component: CONST_COMPONENT.ACTION_BUTTON,
        visibility: 0,
        // visibility: is_system_generated_action ? 0 : 1,
      },

      // {
      //   icon: 'fas fa-paper-plane postback-new',
      //   name: lingualName.POSTBACK_NEW,
      //   component: CONST_COMPONENT.POSTBACK_NEW,
      //   visibility: 1,
      // }, 

    ]
  }),

  methods: {
    handleScrollbar() {
      $('#content-elements-scrollbar').niceScroll({
        cursorcolor: '#cddeed'
      })
    },

    handleElementContentHeight () {
      const offsetHeight = document.getElementById('xit-flow-builder').offsetHeight
      if (parseInt(offsetHeight, 10) <= 40) {
        this.elementContentHeight = 0
      } else {
        this.elementContentHeight = document.getElementById('xit-flow-builder').offsetHeight - 30
      }
    },    
  },

  mounted() {
    this.handleScrollbar()
    this.handleElementContentHeight()

    this.$nextTick(function() {
      window.addEventListener('resize', this.handleScrollbar)
      window.addEventListener('resize', this.handleElementContentHeight)
    })    
  },

  beforeDestroy() { // eslint-disable-line
    const contentElementsScrollbarElement = $('#content-elements-scrollbar')
    if (contentElementsScrollbarElement) {
      contentElementsScrollbarElement.getNiceScroll().remove()
    }
    
    window.removeEventListener('resize', this.handleScrollbar)
    window.removeEventListener('resize', this.handleElementContentHeight)   
  }  
}
</script>

<style scoped>
/* Important for nicescroll */
.content-elements-scrollbar {
  height: auto !important;
}
.content-elements-elements {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 6px;
}
</style>
